export const applyRatio = (object: { [key: string]: number }, ratio: number) => {
    const newObject = Object.assign({}, object)
    Object.keys(newObject).forEach((key) => {
        newObject[key] = newObject[key] * ratio
    })
    return newObject
}

export const unapplyRatio = (object: { [key: string]: number }, ratio: number ) => {
    const newObject = Object.assign({}, object)
    Object.keys(newObject).forEach((key) => {
        newObject[key] = newObject[key] / ratio
    })
    return newObject
}

export const rotationToDeg = (rotation: 0 | 1 | 2 | 3) => {
    return rotation * 90
}